import { Flex } from "antd";
import { formatCurrency } from "@/lib/formatCurrency";
const PriceDetails = ({
  title,
  currency,
  amount,
  size = "1rem",
  showMinus = false,
  padding = true,
}) => {
  return (
    <Flex justify='space-between'>
      <span
        span={12}
        className='text-gray-600'
        style={{
          fontSize: size,
        }}
      >
        {title}
      </span>
      <span
        span={12}
        className='text-black'
        style={{
          fontSize: size,
        }}
      >
        {showMinus && "- "}
        {formatCurrency(amount, currency)}
      </span>
    </Flex>
  );
};

export default PriceDetails;
